<template>
  <div ref="snippet">
    <div v-if="storeState.noAccess">
      <div class="no-access">
        <h4> You don't have access to this block 😢, contact your team admin to get it.
          <button @click="store.getHelp" class="btn-link"> Click here to get help.</button>
        </h4>
      </div>
      <div class="no-access">
        <h4> You can also <button @click="newBlock" class="btn-link"> create your own block here</button>
        </h4>
      </div>
    </div>
    <div v-else-if="!storeState.gotBlock" class="tw-flex tw-justify-center">
      <div class="tw-pt-32">
        <v-progress-circular
          indeterminate
          :size="100"
          :width="8"
          color="primary"
        >
        </v-progress-circular>
      </div>
    </div>
    <div v-else-if="storeState.gotBlock">
    <div class="run-container">
      <v-tooltip bottom dark color="#333">
        <template v-slot:activator="{ on }">
          <div class="back">
            <button v-on="on" class="soup-btn" @click="backToBlocks">
              <v-icon large>mdi-arrow-left-circle</v-icon>
            </button>
          </div>
        </template>
        <span class="tooltip-text">Back</span>
        <span class="key">
          <span class="key-inner">esc</span>
        </span>
      </v-tooltip>
      <div 
        @mouseenter="showBlockActions=true"
        @mouseleave="showBlockActions=false"
        class="title-container"
        v-if="(storeState.block.set && storeState.block.set.type === 'json')"
      >
        <span class="title">
          {{storeState.blocks[storeState.block.set.sql].title}} Schema
        </span>
      </div>
      <div 
        @mouseenter="showBlockActions=true"
        @mouseleave="showBlockActions=false"
        class="title-container"
        v-else
      >
        <span>
          <input :size="storeState.block.title.length > 0 ? storeState.block.title.length+2 : 8" class="title" ref="title" v-model="storeState.block.title" placeholder="Untitled">
        </span>
        
        
      </div>
      <!-- storeState.block.cellType {{storeState.block.cellType}} -->
      <div class="block-container" :style="storeState.runViews[storeState.runView].blockContainer">
        <v-row 
          no-gutters 
          class="block-detail-row"
          @mouseover="hoverSource=true" 
          @mouseleave="hoverSource=false"
          v-if="storeState.block.cellType === 'sql' || storeState.block.cellType === 'sheetsAsSql'"
        >
          <v-col cols="12" sm="2" md="2">
            <div @click="showDestination=true" class="auto-prepend-label clickable">
              <v-icon small class="dest-type-icon">mdi-database</v-icon>
              Source
            </div>
          </v-col>
          <v-col 
            cols="12" 
            :sm="8"
            :md="8"
            class="pad-col-left">
            <v-autocomplete
              ref="source"
              v-model="storeState.block.source.uuid"
              :items="uniqueSources"
              placeholder="Postgres"
              item-text="name"
              item-value="block_uuid"
              auto-select-first
              single-line
              dense
              autocomplete="disabled"
              class="denser"
              @change="focusCm"
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <!-- {{item.name}} -->
                  <v-list-item-title v-html="item.name">{{item}}</v-list-item-title>
                  <v-list-item-subtitle v-html="item.db_type"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <template v-slot:no-data>
                <div></div>
              </template>
              <template v-slot:append-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn text @click="addSource">Add source</v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="storeState.gotSources">
                  <v-list-item-title>
                    <v-btn text @click="editSources">Edit / remove sources</v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn text @click="sheetsAsSource">Use Sheets as source</v-btn>
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <button tabindex="-1" @click="showDestination = !showDestination" class="soup-btn right pad-btn">
              <v-icon v-if="!showDestination">mdi-chevron-down</v-icon>
              <v-icon v-else>mdi-chevron-up</v-icon>
            </button>
            <v-dialog :value="storeState.addingSource" v-model="storeState.addingSource" persistent retain-focus max-width="600px">
              <template v-slot:activator="{ on2 }">
                <!-- <button @click="addSource" v-on="on">
                  <v-icon>mdi-plus</v-icon> New source
                </button> -->
                <button tabindex="-1" class="soup-btn right" @click="addSource" v-on="on2">
                  <v-icon>mdi-plus</v-icon>
                </button>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">New source</span>
                </v-card-title>
                <v-card-text v-if="newSource.db_type != 'snowflake'">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="4" md="4">
                        <v-select
                        :items="dbTypes"
                        v-model="newSource.db_type"
                        item-text="label"
                        item-value="key"
                        label="Flavor"
                        required
                        outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="8" md="8">
                        <v-text-field 
                          ref="newSourceName"
                          v-model="newSource.name"
                          autocomplete="off"
                          :rules="[sourceRules.required, sourceRules.portMin]"
                          label="Nickname" 
                          hint="This can be anything you want"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="9" md="9">
                        <v-text-field 
                          name="host"
                          ref="newSourceHost"
                          v-model="newSource.host" 
                          autocomplete="off"
                          :rules="[sourceRules.required]"
                          label="Host" 
                          hint="Full host name or IP address"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        <v-text-field 
                          v-model="newSource.port" 
                          autocomplete="off"
                          :rules="[sourceRules.required, sourceRules.portMin]"
                          label="Port" 
                          :hint="portHint"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field 
                          name="search-username"
                          ref="newSourceUsername"
                          v-model="newSource.username" 
                          autocomplete="off"
                          :rules="[sourceRules.required]"
                          label="Username" 
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <!-- <v-text-field :value="newSource.password" required password label="Password" ></v-text-field> -->
                        <v-text-field 
                          name="search-password"
                          type="password"
                          v-model="newSource.password" 
                          autocomplete="new-password"
                          label="Password" 
                          hint="Leave blank if no password"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="8" md="8">
                        <v-text-field 
                          name="search-database"
                          v-model="newSource.database" 
                          autocomplete="new-password"
                          label="Database"
                          :rules="[sourceRules.required]"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-checkbox
                          v-model="newSource.ssl"
                          label="Use SSL"
                          class="source-input"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="newSource.ssh"
                          label="Use SSH"
                          class="source-input"
                        ></v-checkbox>
                      </v-col>
                      <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                        <!-- <v-text-field :value="newSource.password" required password label="Password" ></v-text-field> -->
                        <v-text-field 
                          name="sshHost"
                          v-model="newSource.sshHost" 
                          autocomplete="off"
                          :rules="[sourceRules.required]"
                          label="SSH Host" 
                          hint="e.g. e2c-123.amazonaws.com"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                        <v-text-field 
                          name="sshUsername"
                          v-model="newSource.sshUsername" 
                          autocomplete="off"
                          :rules="[sourceRules.required]"
                          label="SSH Username" 
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                        <v-text-field 
                          name="search-ssh-password"
                          type="password"
                          autocomplete="new-password"
                          v-model="newSource.sshPassword"
                          label="SSH Password" 
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                        <v-text-field 
                          name="sshPort"
                          v-model="newSource.sshPort" 
                          autocomplete="off"
                          label="SSH Port (Optional)" 
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col v-if="newSource.ssh" cols="12" sm="12" md="12">
                        <v-textarea 
                          name="sshPrivateKey"
                          v-model="newSource.sshPrivateKey" 
                          autocomplete="off"
                          label="Private Key (Optional)" 
                          class="source-input"
                          outlined
                          >
                        </v-textarea>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <p style="font-size: 16px;" :class="{'whitelist-error': whitelistError, }">
                          You need to whitelist our IP addresses (35.193.207.79 and 35.239.74.213) for your connection to work.</p>
                        <a 
                          href="https://intercom.help/seekwell/en/collections/2052529-connecting"
                          target="_blank"
                        >
                          <strong class="tw-text-blue-500" style="font-size: 16px;">
                            Need help with this?
                          </strong>
                        </a>
                      </v-col>
                    </v-row>
                    
                  </v-container>
                </v-card-text>
                <v-card-text v-else>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="4" md="4">
                        <v-select
                        :items="dbTypes"
                        v-model="newSource.db_type"
                        item-text="label"
                        item-value="key"
                        label="Flavor"
                        required
                        outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="8" md="8">
                        <v-text-field
                          ref="newSourceName"
                          v-model="newSource.name" 
                          autocomplete="off"
                          :rules="[sourceRules.required, sourceRules.portMin]"
                          label="Nickname" 
                          hint="This can be anything you want"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="9" md="9">
                        <v-text-field 
                          name="host"
                          ref="newSourceAccountName"
                          v-model="newSource.accountName" 
                          autocomplete="off"
                          :rules="[sourceRules.required]"
                          label="Account Name" 
                          hint="Do not include region"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        <v-select
                          :items="snowRegions"
                          v-model="newSource.region"
                          :rules="[sourceRules.required]"
                          label="Region"
                          class="source-input"
                          required
                          outlined
                          ></v-select>
                      </v-col>
                      
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field 
                          name="search-username"
                          ref="newSourceUsername"
                          v-model="newSource.username" 
                          autocomplete="off"
                          :rules="[sourceRules.required]"
                          label="Username" 
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <!-- <v-text-field :value="newSource.password" required password label="Password" ></v-text-field> -->
                        <v-text-field 
                          name="search-password"
                          type="password"
                          v-model="newSource.password" 
                          autocomplete="new-password"
                          label="Password" 
                          hint="Leave blank if no password"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field 
                          name="search-warehouse"
                          v-model="newSource.warehouse" 
                          autocomplete="off"
                          :rules="[sourceRules.required]"
                          label="Warehouse" 
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field 
                          name="search-database"
                          v-model="newSource.database" 
                          autocomplete="new-password"
                          label="Database"
                          :rules="[sourceRules.required]"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field 
                          name="search-database"
                          v-model="newSource.schema" 
                          autocomplete="new-password"
                          label="Schema"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field 
                          name="search-database"
                          v-model="newSource.role" 
                          autocomplete="new-password"
                          label="Role"
                          hint="e.g. ADMIN"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field 
                          name="search-database"
                          v-model="newSource.authenticator" 
                          autocomplete="new-password"
                          label="Authenticator (optional)"
                          class="source-input"
                          outlined
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <a 
                          href="https://intercom.help/seekwell/en/articles/2725663-connecting-to-snowflake"
                          target="_blank"
                        >
                        <strong class="tw-text-blue-500" style="font-size: 16px;">Need help finding this information?</strong>
                        </a>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <div v-if="connectError">
                  <v-row>
                    <div class="error--text connect-error">
                      {{connectError}}
                    </div>
                  </v-row>
                </div>
                <div class="tw-flex tw-justify-end tw-pr-4 tw-pb-4">
                  <v-btn class="tw-pr-4" color="blue darken-1" text @click="cancelAddSource">Cancel</v-btn>
                  <v-btn class="tw-pr-4 tw-text-blue-500" color="blue darken-1" text @click="saveSource" :loading="savingSource">Save</v-btn>
                </div>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row 
          v-if="!editDestination && (storeState.block.cellType === 'sql' || storeState.block.cellType === 'sheetsAsSql')" 
          no-gutters class="block-detail-row" 
          @mouseover="hoverDestination=true" 
          @mouseleave="hoverDestination=false">
          <v-col cols="12" sm="2" md="2">
            <v-select
              v-model="storeState.block.destination.type"
              :items="storeState.destinationTypes"
              label=""
              dense
              class="denser"
            > 
              <template v-slot:selection="data">
                <div :data-type="data.item.value" class="clickable destination-type">
                  <v-icon small style="margin-top: -2px;" class="dest-type-icon">{{data.item.icon}}</v-icon>
                  <strong class="dest-type-label">{{data.item.text}}</strong>
                </div>
              </template>
              <template v-slot:item="data">
                <div :data-type="data.item.value" class="clickable destination-type">
                  <v-icon small>{{data.item.icon}}</v-icon>
                  <strong class="dest-type-label">{{data.item.text}}</strong>
                </div>
              </template>
            </v-select>
          </v-col>
          <v-col @click="editDestination = true" cols="12" sm="8" md="8" class="pad-col-left clickable pad-top5">
            <span class="sw-blue" v-html="store.getDestinationSummary(storeState.block)"></span>
          </v-col>
          <v-col cols="12" sm="2" md="2" v-if="hoverDestination">
            <button @click="editDestination = true" class="soup-btn pad-btn right">
              <v-icon>mdi-pencil</v-icon>
            </button>
            <button storeState.block.destination.type @click="openSheet" class="soup-btn right" v-if="storeState.block.destination.type === 'sheets'">
              <v-icon>mdi-open-in-new</v-icon>
            </button>
          </v-col>
        </v-row>
        <v-row v-if="editDestination" no-gutters class="block-detail-row">
          <v-col cols="12" sm="2" md="2">
            <v-select
              v-model="storeState.block.destination.type"
              :items="storeState.destinationTypes"
              label=""
              dense
              class="denser"
            > 
              <template v-slot:selection="data">
                <div :data-type="data.item.value" class="clickable destination-type">
                  <v-icon small style="margin-top: -2px;" class="dest-type-icon">{{data.item.icon}}</v-icon>
                  <strong class="dest-type-label">{{data.item.text}}</strong>
                </div>
              </template>
              <template v-slot:item="data">
                <div :data-type="data.item.value" class="clickable destination-type">
                  <v-icon small>{{data.item.icon}}</v-icon>
                  <strong class="dest-type-label">{{data.item.text}}</strong>
                </div>
              </template>
            </v-select>
          </v-col>
          <v-col v-if="storeState.block.destination.type === 'sheets' && !storeState.gotSheets" cols="12" sm="8" md="8" class="pad-col-left pad-top5">
            No sheets
          </v-col>
          <v-col v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" cols="12" sm="3" md="3" class="pad-col-left pad-top5">
            <v-autocomplete
              ref="spreadSheets"
              v-model="storeState.block.destination.ss_id"
              :items="storeState.destinations.spreadSheets"
              placeholder="Spreadsheet"
              item-text="name"
              item-value="id"
              auto-select-first
              single-line
              dense
              autocomplete="off"
              class="denser"
              @change="onSpreadSheetChange"
            >
              <template v-slot:append-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn @click="refreshSpreadSheets" text>Refresh</v-btn>
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" cols="12" sm="3" md="3" class="pad-top5">
            <v-autocomplete
              v-model="storeState.block.destination.sheet"
              :items="storeState.destinations.sheets"
              :search-input.sync="searchSheet"
              placeholder="Sheet1"
              auto-select-first
              single-line
              dense
              autocomplete="off"
              class="denser"
              :loading="loadingSheets"
            >
              <template v-slot:no-data>
                <v-list-item v-if="loadingSheets">
                  <v-list-item-title>
                    <v-progress-circular
                      indeterminate
                      :size="20"
                      :width="5"
                      color="primary"
                      class="justify-center align-center"
                    > 
                    </v-progress-circular> Loading
                  </v-list-item-title>
                </v-list-item>
                <div v-else></div>
              </template>
              <template v-slot:append-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn @click="addSheet" text>"<strong>{{ searchSheet }}</strong>" does not exist, add it?</v-btn>
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" cols="12" sm="1" md="1" class="pad-top5">
            <v-text-field
              v-model="storeState.block.destination.cell"
              placeholder="A1"
              single-line
              dense
              autocomplete="off"
              class="denser"
            >
            </v-text-field>
          </v-col>

          <v-col v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" cols="12" sm="1" md="1" class="pad-top5">
            <v-tooltip bottom dark color="#333">
              <template v-slot:activator="{ on }">
                <v-checkbox
                  v-model="storeState.block.destination.sheetsAppend"
                  v-on="on"
                  label="Append"
                  dense
                  small
                  class="denser" 
                ></v-checkbox>
              </template>
              <span class="tooltip-text">
                Append results to the last row (default is to replace rows).
              </span>
            </v-tooltip>
            
          </v-col>
          <v-col v-if="storeState.block.destination.type === 'slack'" cols="12" sm="8" md="8" class="pad-col-left">
            <v-autocomplete
              ref="spreadSheets"
              v-model="storeState.block.destination.channel"
              :items="storeState.destinations.slack.channels.channels"
              placeholder="Channel"
              item-text="name"
              item-value="name"
              auto-select-first
              single-line
              dense
              autocomplete="off"
              class="denser"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn text>Loading</v-btn>
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="storeState.block.destination.type === 'email'" cols="12" sm="8" md="8" class="pad-col-left">
            <v-text-field
              ref="emails"
              v-model="storeState.block.destination.emails"
              placeholder="Emails (comma separated list)"
              single-line
              dense
              autocomplete="off"
              class="denser"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn text>Loading</v-btn>
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-text-field>
          </v-col>
          <v-col v-if="storeState.block.destination.type === 'sync'" cols="12" sm="3" md="3" class="pad-col-left">
            <v-autocomplete
              ref="table"
              v-model="storeState.block.destination.table"
              :items="dbTables"
              :search-input.sync="searchTable"
              placeholder="Table"
              item-text="name"
              item-value="name"
              single-line
              dense
              autocomplete="off"
              class="denser"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title v-if="!loadingMeta">
                    <v-btn @click="addTable" text>"<strong>{{ searchTable }}</strong>" not found, refresh database?</v-btn>
                  </v-list-item-title>
                  <v-list-item-title v-else>
                    <v-progress-circular
                      indeterminate
                      :size="20"
                      :width="5"
                      color="primary"
                      class="justify-center align-center"
                    > 
                    </v-progress-circular> Loading
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="storeState.block.destination.type === 'sync'" cols="12" sm="3" md="3">
            <v-autocomplete
              ref="table"
              v-model="storeState.block.destination.primaryKey"
              :items="dbPrimaryKeys"
              :search-input.sync="searchPrimaryKey"
              placeholder="Primary Key"
              item-text="name"
              item-value="name"
              single-line
              dense
              autocomplete="off"
              class="denser"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title v-if="!loadingMeta">
                    <span>"<strong>{{ searchPrimaryKey }}</strong>" does not exist</span>
                  </v-list-item-title>
                  <v-list-item-title v-else>
                    <v-progress-circular
                      indeterminate
                      :size="20"
                      :width="5"
                      color="primary"
                      class="justify-center align-center"
                    > 
                    </v-progress-circular> Loading
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="storeState.block.destination.type === 'sync'" cols="12" sm="2" md="2">
            <v-checkbox
              v-model="storeState.block.destination.isAutoIncrement"
              label="Auto"
              dense
              small
              class="denser" 
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <button @click="editDestination = false" class="soup-btn pad-btn right">
              <v-icon>mdi-check</v-icon>
            </button>
            <button @click="clearDestination" class="soup-btn right">
              <v-icon>mdi-close</v-icon>
            </button>
          </v-col>
        </v-row>
        <v-row v-if="showDestination && editRepeat" no-gutters class="block-detail-row" style="padding-top:4px;">
          <v-col cols="12" sm="2" md="2">
            <div class="auto-prepend-label">
              <v-icon small class="dest-type-icon">mdi-update</v-icon>
              Repeat
            </div>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pad-col-left">
            <v-select
              ref="repeatPeriod"
              :items="intervals"
              v-model="storeState.block.repeat.period"
              placeholder="Every"
              single-line
              dense
              class="denser"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              ref="minutesPast"
              v-if="storeState.block.repeat.period === 'hourly'"
              placeholder="Minutes past"
              v-model="storeState.block.repeat.minutesPast"
              single-line
              dense
              class="denser"
              
            ></v-text-field>
            <div v-if="['daily', 'weekly'].includes(storeState.block.repeat.period)">
              <v-select
                placeholder="Time"
                :items="runTimes"
                v-model="storeState.block.repeat.runTime"
                single-line
                dense
                class="denser run-time"
              ></v-select> 
              <a id = "utcTime" href="https://www.google.com/search?q=utc+time+converter" target="_blank">UTC</a>
            </div>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <div v-if="storeState.block.repeat.period === 'weekly'">
              <v-select
                placeholder="Day"
                :items="daysOfWeek"
                v-model="storeState.block.repeat.dayOfWeek"
                single-line
                dense
                class="denser run-time"
              ></v-select> 
            </div>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <button @click="editRepeat = false" class="soup-btn right pad-btn">
              <v-icon>mdi-check</v-icon>
            </button>
            <button @click="clearRepeat" class="soup-btn right">
              <v-icon>mdi-close</v-icon>
            </button>
          </v-col>
        </v-row>
        <v-row v-if="showDestination && !editRepeat" no-gutters class="block-detail-row" style="padding-top:4px;"
          @mouseover="hoverRepeat=true" @mouseleave="hoverRepeat=false">
          <v-col cols="12" sm="2" md="2">
            <div class="auto-prepend-label">
              <v-icon small class="dest-type-icon">mdi-update</v-icon>
              Repeat
            </div>
          </v-col>
          <v-col v-if="storeState.settings.user.me.trial_expired > 0" 
            cols="12" sm="9" md="9" class="pad-col-left">
            <a href="https://seekwell.io/pricing" target="_blank" class="sw-blue">
              Trial expired, upgrade to continue scheduling
            </a>
          </v-col>
          <v-col v-else @click="editRepeat = true" cols="12" sm="9" md="9" class="pad-col-left clickable">
            {{getRepeat(storeState.block.repeat)}}
          </v-col>
          <v-col cols="12" sm="1" md="1" v-if="hoverRepeat">
            <button @click="editRepeat = true" class="soup-btn right pad-btn">
              <v-icon>mdi-pencil</v-icon>
            </button>
            <button @click="clearRepeat" class="soup-btn right">
              <v-icon>mdi-close</v-icon>
            </button>
          </v-col>
        </v-row>
        <!-- TAGSSSSSSSSSSS -->
        <v-row v-if="showDestination" no-gutters class="block-detail-row" style="padding-top:4px;">
          <v-col cols="12" sm="2" md="2">
            <div class="auto-prepend-label">
              <v-icon small class="dest-type-icon">mdi-tag</v-icon>
              Tags
            </div>
          </v-col>
          <v-col cols="12" sm="8" md="8" class="pad-col-left">
            <template>
              <v-combobox
                ref="tagCombobox"
                v-model="storeState.block.tags"
                :items="storeState.blockTags"
                chips
                label="e.g. revenue"
                multiple
                single-line
                auto-select-first
                hide-selected
                :rules="tagRules"
                :search-input.sync="tagInput"
                append-icon=''
                @keyup.native.enter="tagAddedEnter()"
                dense
                class="denser"
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected.text"
                    close
                    dense
                    close-icon="mdi-close"
                    label
                    @click="selectTag"
                    @click:close="removeTag(item)"
                  >
                    {{ item.text }}
                  </v-chip>
                </template>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No existing tags for "<strong>{{ tagInput }}</strong>" <v-btn class="create-tag" @click="createTag(tagInput)">create one?</v-btn>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </template>
          </v-col>
          <v-col cols="12" sm="2" md="2">
          </v-col>
        </v-row>
        <v-row no-gutters class="block-detail-row">
          <v-col cols="12" sm="2" md="2">
            <div class="auto-prepend-label">
              <v-icon small class="dest-type-icon">mdi-tune</v-icon>
              Defaults
            </div>
          </v-col>
          <v-col cols="12" sm="8" md="8" class="pad-col-left">
            <v-row>
              <v-col cols="12" sm="4" md="4" class="col-no-pad"
                v-for="(item, index) in storeState.block.params"
                :key="index"
              >
                <v-text-field
                  v-if="item.type === 'sheets' && item.spreadSheet"
                  v-model="item.sheet" 
                  autocomplete="off"
                  :placeholder="'Range for ' + item.name"
                  :ref="'param_' + item.name"
                  hint=""
                  dense
                  class="denser"
                  >
                </v-text-field>
                <v-autocomplete
                  v-else-if="item.type === 'sheets'"
                  v-model="item.spreadSheet"
                  :items="storeState.destinations.spreadSheets"
                  placeholder="Spreadsheet"
                  item-text="name"
                  item-value="id"
                  auto-select-first
                  single-line
                  dense
                  autocomplete="off"
                  class="denser"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        <v-btn @click="refreshSpreadSheets" text>Refresh</v-btn>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
                <v-text-field
                  v-else
                  v-model="item.value" 
                  autocomplete="off"
                  :placeholder="item.name || 'no label'"
                  :ref="'param_' + item.name"
                  hint=""
                  dense
                  class="denser"
                  >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="2" md="2">
          </v-col>
        </v-row>
        <div class="code">
          <codemirror 
            @focus="onCmFocus" 
            @blur="onCmBlur"
            @input="onCmChange"
            @ready="onCmReady"
            :options="cmOptions" 
            :value="this.storeState.block.code"
            :style="storeState.runViews[storeState.runView].cm"
            ref="cm"
            >
          </codemirror>
        </div>
        <div class="block-footer">
          <v-divider></v-divider>
          <v-row no-gutters class="tw-pt-4">
            <v-col cols="12" sm="3" md="3">
              <v-tooltip right dark color="#333">
                <template v-slot:activator="{ on }">
                  <button ref="runBtn" v-on="on" @click="saveSnippet" :class="{'soup-btn': true}">
                    <!-- <v-icon class="run-icon">mdi-check</v-icon> -->
                    <strong class="tw-pl-0">Done</strong>
                  </button>
                </template>
                <span class="tooltip-text">Done</span>
                <span class="key">
                  <span v-if="storeState.isMac" class="key-inner key-inner-icon">
                    <v-icon color="#fff !important" size="12">mdi-apple-keyboard-command</v-icon>
                  </span>
                  <span v-else class="key-inner">
                    Ctrl
                  </span>
                </span>
                <span class="key">
                  <span class="key-inner">enter</span>
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="6" md="6"></v-col>
            <v-col cols="12" sm="3" md="3">
              <v-tooltip left dark color="#333">
                <template v-slot:activator="{ on }">
                  <button v-on="on" @click="favoriteBlock" class="soup-btn right pad-btn">
                    <v-icon>{{storeState.block.favorite ? 'mdi-star' : 'mdi-star-outline'}}</v-icon>
                  </button>
                </template>
                <span class="tooltip-text">{{storeState.block.favorite ? 'Unfavorite' : 'Favorite'}}</span>
                <span class="key">
                  <span class="key-inner">S</span>
                </span>
              </v-tooltip>
              <v-tooltip left dark color="#333">
                <template v-slot:activator="{ on }">
                  <button v-on="on" @click="deleteBlock(storeState.block)" class="soup-btn right pad-btn">
                    <v-icon>mdi-delete</v-icon>
                  </button>
                </template>
                <span class="tooltip-text">Delete snippet</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <div class="tw-pt-8 tw-px-24">
      <div class="tw-border-l-4 tw-ml-2 tw-border-gray-500 tw-pl-3 tw-whitespace-pre-wrap tw-font-mono" v-html="renderedSnippet"></div>
    </div>
    <div style="padding-top: 300px;" v-if="storeState.showDebugStuff">
      <pre>this.storeState.searchIndex {{storeState.searchIndex}}</pre>
      <pre>storeState.block {{storeState.block}}</pre>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import debounce from 'debounce'
import { store } from '../store.js';
import { codemirror } from 'vue-codemirror'
import _ from 'lodash';
import LineChart from './LineChart.js'
import BarChart from './BarChart.js'

// import '../assets/styles/codemirror.css'
import '../../node_modules/codemirror/lib/codemirror.css'
import '../../node_modules/codemirror/theme/solarized.css'
import '../../node_modules/codemirror/mode/sql/sql.js'
import '../../node_modules/codemirror/mode/javascript/javascript.js'
import '../../node_modules/codemirror/addon/display/placeholder.js'
import '../../node_modules/codemirror/addon/display/autorefresh.js'
import '../../node_modules/codemirror/addon/comment/comment.js'
import '../../node_modules/codemirror/addon/edit/matchbrackets.js'
import '../../node_modules/codemirror/addon/edit/closebrackets.js'

var toggleComment = require('codemirror/addon/comment/comment.js');
function toggleSqlComment(cm) {
  cm.toggleComment({
    indent: true,
    lineComment: '--'
  });
}

var CodeMirror = require('../../node_modules/codemirror/lib/codemirror.js')


document.body.setAttribute('data-app', true)

export default {
  mounted() {
    // window.bus.$on('hideSuggestions', (details) => {
      // this.storeState.showSuggestions = false
    // });
  },
  data() {
    return {
      store: store,
      storeState: store.state,
      currentRunTime: store.state.currentRunTime,
      stopResize: true,
      dateNlpSearch: '',
      linkColor: 'color: rgb(46, 170, 220)',
      iconLookUp: {
        number: 'mdi-numeric',
        string: 'mdi-format-text',
        date: 'mdi-calendar-blank',
        time: 'mdi-calendar-blank',
      },
      noValueOperators: ['isNotNull', 'isNull'],
      filterSuggestions: [],
      filterOperators: {
        number: [
          {display: '=', sql: '$field = $value', text: 'Equal to', key: 'equalTo'},
          {display: '≠', sql: '!=', text: 'Not equal to', key: 'notEqualTo'},
          {display: '≥', sql: '>=', text: 'Greater than or equal to', key: 'gte'},
          {display: '≤', sql: '<=', text: 'Less than or equal to', key: 'lte'},
          {display: '>', sql: '>', text: 'Greater than', key: 'gt'},
          {display: '<', sql: '<', text: 'Less than', key: 'lt'},
          {display: 'Null', sql: 'IS NULL', text: 'Null', key: 'isNull'},
          {display: 'Not Null', sql: 'IS NOT NULL', text: 'Not Null', key: 'isNotNull'},
        ],
        string: [
          {display: 'Is', sql: '=', text: 'Is', key: 'notNull'},
          {display: 'Is Not', sql: '!=', text: 'Is not', key: 'notNull'},
          {display: 'Contains', sql: `$field LIKE '%$value%'`, text: 'Contains', key: 'contains'},
          {display: 'Does not contain', sql: `$field NOT LIKE '%$value%'`, text: 'Contains', key: 'notContain'},
          {display: 'Starts With', sql: `$field LIKE '$value%'`, text: 'Contains', key: 'startsWith'},
          {display: 'Ends With', sql: `$field LIKE '%$value'`, text: 'Contains', key: 'endsWith'},
          {display: 'Is Null', sql: `$field IS NULL`, text: 'Is Null', key: 'isNull'},
          {display: 'Is Not Null', sql: '$field IS NOT NULL', text: 'Is Not Null', key: 'isNotNull'},
        ],
        time: [
          {display: 'Is', sql: `CAST($field AS DATE) = '$value'`, text: 'Is', key: 'exactDate', dateNlp: true},
          {display: 'Is in the past', sql: `$field > current_date - interval '$num' $period`, 
            text: 'Is', key: 'dateInThePast', dateNlp: false, period: true},
          {display: 'Is on or after', sql: `$field >= '$value'`, text: 'Is after', key: 'dateOnOrAfter', dateNlp: true},
          {display: 'Is after', sql: `$field > '$value'`, text: 'Is after', key: 'dateAfter', dateNlp: true},
          {display: 'Is on or before', sql: `$field <= '$value'`, text: 'Is after', key: 'dateOnOrBefore', dateNlp: true},
          {display: 'Is before', sql: `$field < '$value'`, text: 'Is after', key: 'dateBefore', dateNlp: true},
        ]
      },
      showSidebar: false,
      andOr: [
        {text: 'And', value: 'and'},
        {text: 'Or', value: 'or'},
      ],
      showFilters: false,
      // https://coolors.co/50514f-f25f5c-ffe066-247ba0-70c1b3
      defaultColorScheme: [
        {color: '#F25F5C', nickname: 'red', primary: true},
        {color: '#247BA0', nickname: 'blue', primary: true},
        {color: '#FFE066', nickname: 'yellow', primary: false},
        {color: '#70C1B3', nickname: 'green', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#fff', nickname: 'white', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
      ],
      chartStyles: {
        height: '400px',
        width: '100%',
        position: 'relative',
      },
      chartReady: false,
      showTable: true,
      showChart: false,
      showSql: false,
      dbMeta: false,
      showContextMenu: false,
      whitelistError: false,
      contextData: {},
      contextOptions: [],
      datacollection: null,
      upDownInitiated: false,
      suggestionTop: '0px',
      suggestionLeft: '-1000px',
      suggestionOverlayTop: '0px',
      suggestionOverlayLeft: '-1000px',
      searchTerm: '',
      origSearchTerm: '',
      beforeSearch: '',
      maxSuggestions: 7,
      tagInput: '',
      tagRules: [
        v => false
      ],
      editingTag: false,
      jsonParseError: '',
      newTag: '',
      showBlockActions: false,
      historyOpen: false,
      connectError: '',
      sourceRules: {
        required: value => !!value || 'Required.',
        portMin: v => v.length >= 2 || 'Min 2 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
      snowRegions: [
        "us-west-1", "us-west-2", "us-east-1", "us-east-2.aws", "us-east-2.azure", "eu-west-1", "eu-central-1", "ca-central-1", 
        "ap-southeast-1", "ap-southeast-2", "east-us-2.azure", "us-gov-virginia.azure", 
        "west-europe.azure", "australia-east.azure"
      ],
      hoverDestination: false,
      hoverRepeat: false,
      hoverSource: false,
      intervals: [
        {value: 'hourly', text: 'Hourly'},
        {value: 'daily', text: 'Daily'},
        {value: 'weekly', text: 'Weekly'},
        // {value: 'monthly', text: 'Monthly'},
        {value: 'fivemin', text: '5 minutes'},
      ],
      daysOfWeek: [
        {value: 'monday', text: 'Monday'},
        {value: 'tuesday', text: 'Tuesday'},
        {value: 'wednesday', text: 'Wednesday'},
        {value: 'thursday', text: 'Thursday'},
        {value: 'friday', text: 'Friday'},
        {value: 'saturday', text: 'Saturday'},
        {value: 'sunday', text: 'Sunday'},
      ],
      searchSheet: null,
      searchTable: null,
      searchPrimaryKey: null,
      showDestination: false,
      editDestination: false,
      editRepeat: false,
      loadingSheets: false,
      loadingMeta: false,
      dbTypes: [
        {key: 'mysql', label: 'MySQL', portHint: 'e.g. 3306'}, 
        {key: 'postgres',  label: 'Postgres', portHint: 'e.g. 5432'},
        {key: 'snowflake',  label: 'Snowflake'},
        {key: 'mssql',  label: 'MS SQL Server', portHint: 'e.g. 1433'},
        {key: 'redshift',  label: 'Redshift', portHint: 'e.g. 5439'} 
      ],
      showPass: false,
      newSource: {
        name: '',
        db_type: 'mysql',
        host: '',
        port: '',
        ssl: false,
        username: '',
        password: '',
        database: '',
        metadata: false,
      },
      savingSource: false,
      addingSchedule: false,
      savingSchedule: false,
      cmOptions: {
        tabSize: 4,
        mode: 'text/x-mysql',
        lineNumbers: false,
        line: false,
        placeholder: `Add snippet, e.g. date_trunc('day', {{date}}) as {{label}}_day`,
        autofocus: store.state.cmAutofocus,
        matchBrackets: true,
        autoCloseBrackets: true,
        autoRefresh: true,
        extraKeys: {
          'Shift-Tab': 'indentLess',
          "Cmd-/": toggleSqlComment,
          "Ctrl-/": toggleSqlComment,
        }
      },
    };
  },
  filters: {
    dateFilter: function (date) {
      console.log(date)
      date = date.fromNow()
      return date
      // return moment(date).fromNow();
    }
  },
  computed: {
    getRunTime() {
      let runTime = moment.unix(moment()).utc()._i - this.storeState.block.results.meta.lastRun
      return (runTime / 1000000).toFixed(2)
    },
    renderedSnippet() {
      let block = this.storeState.block
      var snippet = ''
      if (block.params) {
        let params = {}
        for (let i = 0; i < block.params.length; i++) {
          params[block.params[i].name] = block.params[i].value
        }
        snippet = store.interpolate(block.code)(params)
      } else {
        snippet = block.code
      }
      return snippet
    },
    cmAutofocus: function () {
      return storeState.cmAutofocus
    },
    uniqueSources: function () {
      let result = []
      let uniqueNickNames = []
      if (this.storeState.block.source.uuid) {
        let curS = this.storeState.allSources.find(o => o.block_uuid === this.storeState.block.source.uuid)
        if (curS) {
          result.push(curS)
          uniqueNickNames.push(curS.name)
        }
      }
      for (let i = 0; i < this.storeState.allSources.length; i++) {
        let source = this.storeState.allSources[i]
        if (!uniqueNickNames.includes(source.name)) {
          uniqueNickNames.push(source.name)
          result.push(source)
        }
      }
      result = result.concat(this.storeState.sets)
      return result
    },
    dbTables: function () {
      return this.storeState.dbMeta.tables
    },
    dbPrimaryKeys: function () {
      console.log('dbPrimaryKeys: ', this.storeState.block.destination)
      if (this.storeState.dbMeta && this.storeState.block.destination.table) {
        console.log('dbPrimaryKeys: ', this.storeState.block.destination.table)
        // let schemaName = this.storeState.block.destination.table.split('.')[0]
        // let schema = this.storeState.dbMeta.schemas[schemaName]
        // let table = schema[this.storeState.block.destination.table.split('.')[1]]
        let rows = this.storeState.dbMeta.df.filter(row => `${row.table_schema}.${row.table_name}` === this.storeState.block.destination.table)
        // let columns = row.map(row => row.column_name)
        return rows.map(row => row.column_name)
      }
      return []
    },
    // blockHistory: function () {
    //   let blockLs = Object.keys(this.storeState.blocks).map(id => this.storeState.blocks[id])
    //   return blockLs.sort(store.compareValues('viewOn', 'desc')).slice(0, 9)
    // },
    portHint: function () {
      let hint = this.dbTypes.find(d => d.key === this.newSource.db_type).portHint
      return hint || ''
    },    
    runTimes: function () {
      let mins = _.range(0, 59, 5)
      let hours = _.range(0, 23, 1)
      let times = []

      for (let i = 0; i < hours.length; i++) {
        let hour = hours[i];
        for (let i = 0; i < mins.length; i++) {
          times.push(`${_.padStart(hour, 2, '0')}:${_.padStart(mins[i], 2, '0')}`)
        }
      }
      return times
    }
  },
  components: {
    codemirror,
    LineChart,
    BarChart,
  },
  watch: {
    newSource: {
        handler: function (val, oldVal) {
          // this.$route.params.id = val
        },
        deep: true,
    },
    'storeState.block.viz.chartJsOptions.legend': {
      handler: function (newVal, oldVal) {
        console.log('watch chart options', 'newval: ', newVal, '   oldVal:', oldVal)
      },
      deep: true,
    },
    'storeState.block.repeat.period': {
        handler: function (val, oldVal) {
          console.log('storeState.block.repeat.period: ', val, oldVal)

        },
        deep: true,
    },
    'storeState.block.results.headers': {
        handler: function (val, oldVal) {
          console.log('storeState.block.results.headers: ', val, oldVal)
          if (val.length > 0) this.updateSetSchemaAfterRun()
        },
        deep: true,
    },
    'storeState.block.tags': {
        handler: function (val, oldVal) {
          console.log('storeState.block.tags: ', val, oldVal)
          var tags = []
          tags.push(this.storeState.setTag)
          for (let [key, value] of Object.entries(this.storeState.blocks)) {
            let blockTagKeys = value.tags.map(t => t.value)
            let allTagKeys = tags.map(t => t.value)
            let newTags = _.difference(blockTagKeys, allTagKeys)
            if (newTags.length > 0 && newTags[0]) {
              for (let i = 0; i < newTags.length; i++) {
                tags.push(value.tags.find(t => t.value === newTags[i]))
              }
            }
          }
          // let setTag = tags.find(t => t.text === 'Set')
          // if (!setTag) tags.push(this.storeState.setTag)
          this.storeState.blockTags = tags
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          console.log('this.storeState.blockTags: ', this.storeState.blockTags)
          this.$forceUpdate()
        },
        deep: true,
    },
    'storeState.block.code': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          if (this.storeState.block.cellType === 'sql') store.updateAst()          
        },
        deep: true
    },
    'storeState.block.title': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          if (this.storeState.block.title && this.storeState.block.title.length > 0) {
            document.title = this.storeState.block.title;
          }
        },
        deep: false
    },
    'storeState.block.destination': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.source': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          if (this.storeState.block.cellType === 'snippet') {
            // dont change
          } else if (val.type === 'sheets' || val.uuid === 'googlesheets') {
            this.storeState.block.cellType = 'sheetsAsSql'
          } else {
            this.storeState.block.cellType = 'sql'
          }
        },
        deep: true
    },
    'storeState.block.repeat': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.favorite': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        }
    },
    'storeState.block.params': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.tableLoading': {
        handler: function (val, oldVal) {
          console.log('tableLoading 1', 'newval: ', val, '   oldVal:', oldVal)
        },
        deep: true
    },
    '$route.params.id': function (newId, oldId) {
      console.log('uuid changed', newId, oldId)
      this.getBlock(newId)
    },
    'storeState.block.source.uuid': {
        handler: function (newId, oldId) {
          console.log('new source id: ', newId, 'old was: ', oldId)
          if (newId === oldId) return
          let u = this.storeState.allSources.find(s => s.block_uuid === newId)
          let old = this.storeState.allSources.find(s => s.block_uuid === oldId)
          if (u && u.type === 'sheets') {
            this.storeState.block.cellType = 'sheetsAsSql'
            return
          } else if (u && u.name) {
            if (old && u.name === old.name) return
            this.storeState.block.source.name = u.text || u.name
            this.storeState.block.cellType = 'sql'
            this.cmOptions.mode = 'text/x-mysql'
            this.getExplore(this)
            return
          } else {
            var set = this.storeState.sets.find(s => s.block_uuid === newId)
          }
          if (set) {
            console.log('selected model', set)
            this.storeState.block.source.name = set.name
            this.storeState.block.source.uuid = set.block_uuid
            this.storeState.block.cellType = 'set'
            this.cmOptions.mode = 'javascript'
            if (this.storeState.block.code.length < 3) {
              Object.entries(this.storeState.blocks).forEach(([key, value]) => {
                if (key === set.block_uuid) {
                  var j = {}
                  for (let i = 0; i < value.results.headers.length; i++) {
                    let el = value.results.headers[i];
                    console.log(el)
                    j[el.value] = {
                      label: this.makeLabel(el.value),
                      type: this.getSetColType(el),
                    }
                  }
                  j['count'] = {
                    "label": "Count",
                    "measure": true,
                    "type": "count"
                  }
                  j = {fields: j, filters: {}}
                  j = JSON.stringify(j, null, '\t')
                  this.storeState.block.code = j
                  console.log('modelBlock', value)
                }
              })
            }
            return
          }
          setTimeout(() => {
            this.$forceUpdate()
          }, 0);
          let source = this.storeState.sources.find(s => s.block_uuid === newId)
          // if (source && source.meta) this.storeState.dbMeta = source.meta
          if (source && source.name) this.storeState.block.source.name = source.name
        },
        deep: true
    },
    'storeState.sources': {
        handler: function (newVal, oldVal) {
          if (this.storeState.block.source && this.storeState.block.source.uuid) {
            let source = this.storeState.sources.find(s => s.block_uuid === this.storeState.block.source.uuid)
            if (source && source.meta) this.storeState.dbMeta = source.meta
          }
        },
        deep: true
    },
    'storeState.block.results.rows': {
        handler: function (val, oldVal) {
          if (this.storeState.block && this.storeState.block.results.rows.length > 0) {
            store.updateBlock({gotBlock: this.storeState.gotBlock})
            this.makeChart()
          }
        },
        deep: true
    },
    'storeState.block.viz': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
  },
  methods: {
    startDrag(e) {
      console.log(e)
      this.stopResize = false
    },
    saveSnippet() {
      this.backToBlocks()
    },
    resizeOutput() {
      setTimeout(() => {
        
      }, 50);
    },
    cancelAddSource() {
      this.storeState.addingSource = false
      this.savingSource = false
    },
    hideFilters() {
      this.showFilters = false
    },
    addFilter() {
      let filter = {
        andOr: false,
        field: '',
        operator: '=',
        value: '',
      }
      if (this.storeState.block.set.filters.length > 0) {
        filter.andOr = 'and'
      }
      this.storeState.block.set.filters.push(filter)
    },
    removeFilter(index) {
      this.storeState.block.set.filters.splice(index, 1)
      this.showFilters = true
    },
    makeChart() {
      console.log('make chart')
      this.chartReady = false
      let dm = this.getDimensionsMeasures(this.storeState.block.results.rows)
      if (dm.dimensions.length === 0) return
      this.storeState.block.viz.datacollection = {
        labels: this.getChartLabels(this.storeState.block.results.rows, dm),
        datasets: this.getChartData(this.storeState.block.results.rows, dm),
      }
      this.chartReady = true
    },
    flipStacked() {
      this.storeState.block.viz.stacked = !this.storeState.block.viz.stacked
      if (this.storeState.block.viz.stacked) {
        this.storeState.block.viz.chartJsOptions.scales = {
          xAxes: [{
              stacked: true
          }],
          yAxes: [{
              stacked: true
          }]
        }
      } else {
        this.storeState.block.viz.chartJsOptions.scales = {}
      }
      // this.$forceUpdate()
      this.makeChart()
    },
    flipFill() {
      this.storeState.block.viz.fill = !this.storeState.block.viz.fill
      // this.$forceUpdate()
      this.makeChart()
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getTypeIcon(row) {
      if (row.measure) return 'mdi-numeric'
      if (!row.type) return 'mdi-format-text'
      return this.storeState.iconLookUp[row.type]
    },
    vizRowClick(row) {
      let changed = this.storeState.block.setQueryThings.findIndex(q => q.suggestionUuid === row.suggestionUuid)
      this.storeState.block.setQueryThings[changed].selected = !this.storeState.block.setQueryThings[changed].selected
      this.makeChart()
      this.$forceUpdate()
    },
    showFiltersNow()  {
      this.showFilters = !this.showFilters
      this.getFilterSuggestions()
      this.getFilterOperators()
      this.$forceUpdate()
    },
    showTableNow() {
      this.showTable = true
      this.showChart = false
    },
    showChartNow() {
      this.showTable = false
      this.showChart = true
    },
    getAllFieldsForSet(setBlockId) {
      var self = this
      let set = this.storeState.blocks[setBlockId]
      var setFields = JSON.parse(set.code).fields
      let fields = []
      for (let [key, value] of Object.entries(setFields)) {
        let f = value
        f.path = `${set.name}.${key}`
        f.name = `${value.name || key}`
        f.uuid = set.block_uuid
        f.setJsonId = set.setJsonId
        f.suggestionUuid = store.uuidv4()
        f.setType = 'field'
        f.selected = true
        fields.push(f)
      }
      return fields
    },
    getDimensionsMeasures(d) {
      let dimensions = []
      let measures = []
      if (this.storeState.block.setQueryThings.length === 1) {
        var allFields = this.getAllFieldsForSet(this.storeState.block.setQueryThings[0])
        this.storeState.block.setQueryThings = [...allFields, ...this.storeState.block.setQueryThings]
      }
      for (let i = 0; i < this.storeState.block.setQueryThings.length; i++) {
      // for (let [key, obj] of Object.entries(d[0])) {
        // let setInfo = this.storeState.block.setQueryThings.find(t => t.label === key || t.name === key)
        let setInfo = this.storeState.block.setQueryThings[i]
        if (!setInfo) {
          //do nothing
        } else if (setInfo.measure) {
          console.log('found measure: ', setInfo)
          setInfo.data = []
          measures.push(setInfo)
        } else {
          dimensions.push(setInfo)
        }
      }
      return {dimensions: dimensions, measures: measures}
    },
    getChartLabels(d, dm) {
      let rows = []
      let dim = dm.dimensions.filter(o => o.selected)[0]
      for (let i = 0; i < d.length; i++) {
        let row = d[i];
        let val = row[dim.label] || row[dim.name]
        rows.push(val)
      }
      return rows
    },
    getChartData(d, dm) {
      let rows = []
      for (let i = 0; i < d.length; i++) {
        let row = d[i];
        // dm.measures[i].data = []
        for (let i2 = 0; i2 < dm.measures.length; i2++) {
          let val = row[dm.measures[i2].label] || row[dm.measures[i2].name]
          dm.measures[i2].data.push(val)
        }
      }
      for (let i = 0; i < dm.measures.length; i++) {
        let el = dm.measures[i];
        if (el.selected) {
          var color = this.defaultColorScheme[i].color
          if (!color) color = this.getRandomColor()
          rows.push({
            label: el.label,
            backgroundColor: color,
            borderColor: color,
            data: el.data,
            fill: this.storeState.block.viz.fill
          })
        }
      }
      return rows
    },
    getFilterSuggestions() {
      this.filterSuggestions = []
      let numPerCategory = 3
      let sets = []
      let fields = []
      var uniqueSetsInSearch = []
      if (this.storeState.block.setQueryThings.length > 0) {
        var uniqueSetsInSearch = _.uniq(_.map(this.storeState.block.setQueryThings, 'set'));
        for (let i = 0; i < this.storeState.block.setQueryThings.length; i++) {
          let thing = this.storeState.block.setQueryThings[i];
          uniqueSetsInSearch.push(thing.set || thing.name)
        }
        uniqueSetsInSearch = _.uniq(uniqueSetsInSearch);
      }
      for (let i = 0; i < this.storeState.sets.length; i++) {
        let set = this.storeState.sets[i];
        if (uniqueSetsInSearch.length > 0 && !uniqueSetsInSearch.includes(set.name)) continue 
        let jsonValid = false
        try {
          JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
          jsonValid = true
        } catch (error) {
          jsonValid = false
        }
        if (!set.setJsonId || !jsonValid) {
          continue
        }
        var setFields = JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
        for (let [key, value] of Object.entries(setFields)) {
          let f = value
          f.path = `${set.name}.${key}`
          f.name = `${key}`
          f.uuid = set.block_uuid
          f.setJsonId = set.setJsonId
          f.suggestionUuid = store.uuidv4()
          f.setType = 'field'
          fields.push(f)
        }
      }
      let fields2 = []
      for (let i2 = 0; i2 < fields.length; i2++) {
        let field = fields[i2];
        let match = {include: true, ratio: 1}
        if (match.include && !field.measure) {
          field.title = field.label || field.name
          field.details = `${field.type} in ${field.path}`
          field.ratio = match.ratio
          field.icon = this.storeState.iconLookUp[field.type]
          field.setType = 'field'
          this.filterSuggestions.push(field)
        }
      }
      this.filterSuggestions = this.filterSuggestions.sort((a, b) => b.ratio - a.ratio);
    },
    showFiltersNow()  {
      this.showFilters = !this.showFilters
      this.getFilterSuggestions()
      this.getFilterOperators()
      this.$forceUpdate()
    },
    onFilterFieldChange() {
      this.getFilterOperators()
    },
    onFilterOperatorChange() {
    },
    getFilterOperators() {
      console.log('getFilterOperators...')
      if (!this.storeState.block.tables) return
      this.tableFilterOperators = []
      for (let i = 0; i < this.storeState.block.set.filters.length; i++) {
        let filter = this.storeState.block.set.filters[i];
        if (!filter.field.type) {
          this.tableFilterOperators[i] = this.filterOperators['string']
        } else {
          this.tableFilterOperators[i] = this.filterOperators[filter.field.type]
        }
      }
      this.$forceUpdate()
    },
    customDataNlpAutoFilter() {
      return true
    },
    getDateNlpSuggestions(index) {
      console.log('getDateNlpSuggestions...')
      let filters = this.storeState.block.set.filters[index]
      var opt = {text: `e.g. "3 days ago"`, value: 'asdfasdf'}
      var parsedDate = chrono.parseDate(this.dateNlpSearch)
      if (parsedDate) {
        console.log('getDateNlpSuggestions...', parsedDate, parsedDate.toDateString())
        let sqlDate = parsedDate.toJSON().replace('T', ' ').slice(0, 10)
        opt = {text: sqlDate, value: sqlDate}
        filters.dateNlpSuggestions = [opt]
        this.$set(this.storeState.block.set.filters, index, filters)
      } else {
        filters.dateNlpSuggestions = []
        let periods = ['days', 'weeks', 'months', 'years', 'hours', 'minutes']
        let exacts = ['yesterday', 'tomorrow', 'today', 'now', 'monday', 'tuesday']
        var includePeriods = []
        let searchParts = this.dateNlpSearch.split(' ')
        let nums = this.dateNlpSearch.match(/(\d+)/)
        var num = 1
        if (nums) num = nums[0]
        var hasYesteday = false
        var hasToday = false
        for (let i = 0; i < searchParts.length; i++) {
          let search = searchParts[i];
          for (let i2 = 0; i2 < periods.length; i2++) {
            let period = periods[i2];
            if (period.startsWith(search)) {
              let p = `${num} ${period} ago`
              var parsedDate = chrono.parseDate(p)
              if (parsedDate) {
                let sqlDate = parsedDate.toJSON().replace('T', ' ').slice(0, 10)
                opt = {text: p, value: sqlDate}
                filters.dateNlpSuggestions.push(opt)
              }
            }
          }
          for (let i2 = 0; i2 < exacts.length; i2++) {
            let exact = exacts[i2];
            if (exact.startsWith(search)) {
              var parsedDate = chrono.parseDate(exact)
              let sqlDate = parsedDate.toJSON().replace('T', ' ').slice(0, 10)
              opt = {text: exact, value: sqlDate}
              filters.dateNlpSuggestions.push(opt)
            }
          }
        }
        this.$set(this.storeState.block.set.filters, index, filters)
      }
    },
    getDatePeriodSuggestions(index) {
      console.log('getDatePeriodSuggestions...')
      let filters = this.storeState.block.set.filters[index]
      filters.dateNlpSuggestions = []
      let periods = ['days', 'months', 'years', 'hours', 'minutes']
      var includePeriods = []
      let searchParts = this.dateNlpSearch.split(' ')
      let nums = this.dateNlpSearch.match(/(\d+)/)
      var num = 1
      if (nums) num = nums[0]
      for (let i = 0; i < periods.length; i++) {
        let period = periods[i];
        for (let i2 = 0; i2 < searchParts.length; i2++) {
          let search = searchParts[i2];
          if (period.startsWith(search)) {
            includePeriods.push(period)
          }
        }
      }
      if (includePeriods.length === 0) includePeriods = periods
      for (let i = 0; i < includePeriods.length; i++) {
        let period = includePeriods[i];
        let opt = {text: `${num} ${period}`, value: `${num} ${period}`, num: num, period: period}
        filters.dateNlpSuggestions.push(opt)
      }
      this.$set(this.storeState.block.set.filters, index, filters)
    },
    changeSort(column) {
      if (this.storeState.block.results.tableOptions.sortBy === column) {
        let direction = !this.storeState.block.results.tableOptions.sortDesc
        this.storeState.block.results.tableOptions.sortDesc = direction
        // this.storeState.block.results.rows = this.storeState.block.results.rows.sort((a, b) => a[column] - b[column]);
        this.storeState.block.results.rows = _.orderBy(this.storeState.block.results.rows, [column], [(direction ? 'desc' : 'asc')]);
      } else {
        this.storeState.block.results.tableOptions.sortBy = column
        this.storeState.block.results.tableOptions.sortDesc = false
        // this.storeState.block.results.rows = this.storeState.block.results.rows.sort((a, b) => b[column] - a[column]);
        this.storeState.block.results.rows = _.orderBy(this.storeState.block.results.rows, [column], ['asc']);

      }
    },
    showContextMenuHeader(e) {
      e.preventDefault()
      console.log('show context', e)
      this.contextOptions = [
        { title: 'Copy column name', icon: 'mdi-content-copy', f: this.copyColumnName },
        // { title: 'Filter', icon: 'mdi-filter', f: this.addFilterFromHeader },
        { title: 'Hide', icon: 'mdi-eye-off-outline', f: this.hideHeader },
      ]
      let headerIndex = e.currentTarget.dataset.headerIndex || e.target.dataset.headerIndex
      let header = this.storeState.block.results.headers[Number(headerIndex)]
      this.contextData.header = header
      this.contextData.x = e.clientX
      this.contextData.y = e.clientY
      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    copyColumnName() {
      this.$copyText(this.contextData.header.text)
      this.storeState.snackbar = true;
      this.storeState.message = `Copied ${this.contextData.header.text}`;
    },
    addFilterFromHeader() {
      this.addFilter({field: this.contextData.header.text})
      this.showFilters = true
    },
    hideHeader() {
      this.storeState.block.results.headers = this.storeState.block.results.headers.filter(h => h.text != this.contextData.header.text)
    },
    focusMinutesPast() {
      this.showDestination = true
      this.editRepeat = true
      setTimeout(() => {
        this.$refs.minutesPast.focus()
      }, 0);
    },
    scheduleUpdates() {
      this.editRepeat=true
      this.showDestination=true
      setTimeout(() => {
        this.$refs.repeatPeriod.focus()
      }, 0);
    },
    getSetColType(dtype) {
      // https://docs.scipy.org/doc/numpy/reference/arrays.dtypes.html
      // sw data type
      // string, number, boolean and time
      let numpyDtype = {
        '?':	'boolean',
        'b':	'string',
        'B':	'string',
        'i':	'number',
        'u':	'number',
        'f':	'number',
        'c':	'number',
        'm':	'time',
        'M':	'time',
        'O':	'string',
        'U':	'string'
        }
      let type = numpyDtype[dtype.kind]
      if (type) return type
      return 'string'
      // if ()
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    evalSuggestion(suggestion, source) {
      var cur = editor.getCursor()
      // if (source === 'click') {
      //   cur = this.storeState.lastCur
      // }
      let line = editor.getRange({line : cur.line, ch : 0}, {line : cur.line, ch : cur.ch})
      if (suggestion) {
        var wordRange = editor.findWordAt(cur);
        this.origSearchTerm = editor.getRange(wordRange.anchor, wordRange.head)
        if (this.origSearchTerm == ' ') {
          cur = {line: cur.line, ch: cur.ch-1, sticky: null}
          var wordRange = editor.findWordAt(cur);
          this.origSearchTerm = editor.getRange(wordRange.anchor, wordRange.head)
        }
        let beforeSearch = editor.getRange({line: wordRange.anchor.line, ch: wordRange.anchor.ch-1}, wordRange.anchor)
        store.autoAddSelected(suggestion, this.storeState.searchTerm, wordRange, beforeSearch, line)
      }
    },
    removeTag(item) {
      this.storeState.block.tags.splice(this.storeState.block.tags.indexOf(item), 1)
      this.storeState.block.tags = [...this.storeState.block.tags]
    },
    betterTab(cm) {
      // https://github.com/codemirror/CodeMirror/issues/988
      if (cm.somethingSelected()) {
        cm.indentSelection("add");
      } else {
        let addThis = Array(window.editor.getOption("indentUnit") + 1).join(" ")
        cm.replaceSelection(addThis)
      }
    },
    handleTab() {
      if (this.storeState.showSuggestions) {
        let idx = this.storeState.searchIndex > 0 ? this.storeState.searchIndex : 0
        let suggestion = this.storeState.compositionSuggestions[idx]
        this.evalSuggestion(suggestion, 'tab')
      } else {
        this.betterTab(window.editor)
      }
    },
    handleEnter() {
      if (this.storeState.showSuggestions && this.storeState.searchIndex >= 0 && this.upDownInitiated) {
        let suggestion = this.storeState.compositionSuggestions[this.storeState.searchIndex]
        this.evalSuggestion(suggestion, 'enter')
      } else {
        this.storeState.showSuggestions = false
        window.editor.execCommand("newlineAndIndent")
      }
      this.upDownInitiated = false
    },
    handleDown() {
      this.upDownInitiated = true
      if (!this.storeState.showSuggestions) window.editor.execCommand('goLineDown')
    },
    handleUp() {
      this.upDownInitiated = true
      if (!this.storeState.showSuggestions) window.editor.execCommand('goLineUp')
    },
    hoverRow(row, index, hover) {
      if (hover) {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = index
      } else {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = -1
      }
    },
    topSuggestion() {
      let idx = this.storeState.searchIndex > 0 ? this.storeState.searchIndex : 0
      let top = this.storeState.compositionSuggestions[idx]
      if (top && this.storeState.searchTerm.length > 0) {
        return ` ⇥ ${top.title}`
      }
      return ''
    },
    rowClick(e) {
      console.log('rowClick: ', e)
      if (!e.currentTarget) return
      let suggestion = this.storeState.compositionSuggestions[e.currentTarget.dataset.index]
      this.evalSuggestion(suggestion, 'click')
    },
    onClick(e) {
      // console.log('click', e, e.target.classList.contains('cm-bracket-sw'))
      if (e.target.classList.contains('cm-bracket-sw')) {
        this.showDestination = true
      }
      // this.storeState.cmdkActive = false;
    },
    getTitle(item) {
      if (!item.title) return 'History'
      if (item.title.length > 15) return item.title.slice(0,15) + '...'
      return item.title
    },
    selectTag(item) {

    },
    makeLabel(s) {
      return s.toLowerCase().split('_').map(s => s.charAt(0).toUpperCase() + s.slice(1)).toString().replace(',', ' ')
    },
    createTag(tag) {
      console.log(tag)
      this.storeState.addingTag = true
      this.storeState.cmdkParentCmd = 'createTag'
      this.$parent.openCmdK({cmdkParentCmd: 'createTag', cmdkInput: tag})
    },
    fromNowFormat: function (data) {
      return moment(data.viewedOn/1000).fromNow()
    },
    fromNowRunFormat: function (data) {
      return moment(data/1000).fromNow()
    },
    clearRepeat() {
      this.storeState.block.repeat = JSON.parse(JSON.stringify(this.storeState.blockTemplate.repeat))
    },
    loadBookFromHistory(uuid) {
      this.$router.push({ name: 'Run', params: {id: uuid }}).catch(err => console.error(err))
      this.getBlock(this.$route.params.id)
    },
    backToSql() {
      this.storeState.block.cellType = 'sql'
    },
    refreshSpreadSheets() {
      this.$parent.getSoupSheets()
    },
    getSqlForSet() {
      let blockId = this.storeState.block.set.sql
      this.$router.push({ name: 'Run', params: {id: blockId}}).catch(err => console.error(err))
    },
    getJsonForSet() {
      if (this.storeState.block.set && this.storeState.block.set.json) {
        let blockId = this.storeState.block.set.json
        this.$router.push({ name: 'Run', params: {id: blockId}}).catch(err => console.error(err))
      } else {
        this.storeState.block.tags.push(this.storeState.setTag)
        let blockId = store.uuidv4()
        this.storeState.newBlocks.push(blockId)
        this.storeState.setSourceId = this.storeState.block.uuid
        this.storeState.block.set.json = blockId
        this.storeState.block.set.type = 'sql'
        this.$router.push({ name: 'Run', params: {id: blockId}}).catch(err => console.error(err))
      }
    },
    goToBlocks() {
      this.$router.push({ name: 'Blocks' }).catch(err => console.error(err))
    },
    newBlock() {
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      this.$router.push({ name: 'Run', params: {id: blockId }}).catch(err => console.error(err))
      this.getBlock(this.$route.params.id)
      let self = this
      setTimeout(() => {
        self.$refs.source.focus()
      }, 0);
    },
    clearDestination() {
      this.storeState.block.destination = JSON.parse(JSON.stringify(this.storeState.blockTemplate.destination))
    },
    sendToSheets() {
      this.showDestination = true
      this.editDestination = true
      this.$nextTick(this.$refs.spreadSheets.focus)
    },
    deleteBlock(block) {
      Vue.delete(this.storeState.blocks, block.uuid)
      store.deleteBlock(block)
      this.$parent.goToSnippets()
    },
    focusSource() {
      this.$nextTick(this.$refs.source.focus)
    },
    focusCm() {
      console.log('focusCm')
      setTimeout(() => {
        if (this.$refs.cm) this.$refs.cm.codemirror.focus()
      }, 100);
    },
    getRepeat(repeat) {
      if (this.storeState.settings.user.me.trial_expired > 0) {
        return 'Trial expired, upgrade to continue scheduling'
      } else if (repeat.period === 'hourly') {
        return `Hourly at ${repeat.minutesPast} minutes past`
      } else if (repeat.period === 'daily') {
        return `Daily at ${repeat.runTime || ' not selected'}`
      } else if (repeat.period === 'weekly') {
        return `Weekly on ${repeat.dayOfWeek.replace(/^\w/, c => c.toUpperCase())} at ${repeat.runTime}`
      } else if (repeat.period === 'monthly') {
        return `Monthly`
      } else if (repeat.period === 'fivemin') {
        return `Every 5 minutes`
      }
      return `Click to set schedule`
    },
    backToBlocks() {
      this.$router.push({ name: 'Blocks'}).catch(err => console.error(err))
    },
    addSheet() {
      this.storeState.destinations.sheets.push(this.searchSheet)
    },
    addTable() {
      this.getExplore(this)
    },
    addPrimaryKey() {
      
    },
    getBlockHistory(uuid) {
      let blockLs = Object.keys(this.storeState.blocks).map(id => this.storeState.blocks[id])
      this.storeState.blockHistory = blockLs.sort((a, b) => { return b.viewedOn - a.viewedOn}).slice(0, 10)
      // this.storeState.blockHistory = blockLs.sort((a, b) => { return b.viewedOn - a.viewedOn}).slice(0, 10)
      // console.log('this.storeState.blockHistory: ', this.storeState.blockHistory)
    },
    getBlock(uuid) {
      console.log('getBlock: ', uuid)
      this.storeState.gotBlock = false
      this.storeState.noAccess = false
      this.cmOptions.mode = 'text/x-mysql'
      if (this.storeState.gotBlocks) {
        let block = this.storeState.blocks[uuid]
        if (block) {
          console.log('getBlock2: ', block)
          block = store.addMissingBlockAttributes(block)
          block.viewedOn = moment.unix(moment()).utc()._i
          this.storeState.block = block
          if (block.destination.sheet && this.storeState.destinations.sheets.length === 0) {
            this.storeState.destinations.sheets.push(block.destination.sheet)
          }
          if (this.storeState.block.title && this.storeState.block.title.length > 0) {
            document.title = this.storeState.block.title;
          } else {
            document.title = 'Untitled'
          }
          setTimeout(() => {
            this.storeState.gotBlock = true
            this.focusCm()
          }, 100);
        } else if (this.storeState.newBlocks.includes(uuid)) {
          this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
          this.storeState.block.uuid = uuid
          document.title = 'Untitled'
          this.storeState.block.cellType = 'snippet'
          this.storeState.showCm = true
          this.storeState.block.tags.push(this.storeState.snippetTag)
          this.focusCm()
          // if (this.$route.params.snippet) {
            //
          // } else if (this.storeState.defaultSource) {
          //   this.storeState.block.source = this.storeState.defaultSource
          //   this.focusCm()
          // }
          this.storeState.gotBlock = true
        } else {
          this.storeState.noAccess = true
          console.log('you dont have access to this block')
        }
      } else {
        setTimeout(() => {
            this.getBlock(uuid)
        }, 300);
      }
      this.getBlockHistory()
    },
    updateSetSchemaAfterRun() {
      if (this.storeState.block.set && this.storeState.block.set.json && this.storeState.blocks[this.storeState.block.set.json]) {
        let schemaBlockId = this.storeState.block.set.json
        this.generateJsonStarterFromHeaders(this.storeState.block.uuid, schemaBlockId)
        store.updateBlock(this.storeState.blocks[this.storeState.block.set.json])
      } else {
        let block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
        block.uuid = store.uuidv4()
        this.storeState.block.set.json = block.uuid
        this.storeState.newBlocks.push(block.uuid)
        block.source.uuid = this.storeState.setSourceId
        block.set.sql = this.storeState.setSourceId
        block.set.type = 'json'
        block.cellType = 'set'
        block.title = this.storeState.block.title + 'Schema'
        block.source = this.storeState.block.source
        block.tags.push(this.storeState.setTag)
        this.storeState.blocks[block.uuid] = block
        store.updateBlock(block)
        this.generateJsonStarterFromHeaders(this.storeState.block.uuid, block.uuid)
      }
    },
    generateJsonStarterFromHeaders(setSourceId, setBlockId) {
      let value = this.storeState.blocks[setSourceId]
      let key = setSourceId
      if (key === setSourceId) {
        var j = {}
        for (let i = 0; i < value.results.headers.length; i++) {
          let el = value.results.headers[i];
          j[el.value] = {
            label: this.makeLabel(el.value),
            type: this.getSetColType(el),
          }
          if (j[el.value].type === 'number') {
            // j[`${el.text}_sum`] = {
            //   "label": `${j[el.value].label} Sum`,
            //   "name": el.text,
            //   "measure": true,
            //   "type": "sum",
            //   "sql": `sum(${el.text})`,
            // }
            j[`${el.text}_raw`] = {
              "label": `${j[el.value].label}`,
              "name": el.text,
              "measure": true,
              "type": "sum",
              "sql": `sum(${el.text})`,
            }
          }
        }
        // j['count'] = {
        //   "label": "Count",
        //   "measure": true,
        //   "type": "count"
        // }
        j = {fields: j, filters: {}}
        j = JSON.stringify(j, null, '\t')
        this.storeState.blocks[setBlockId].code = j
      }
      this.storeState.block.setQueryThings = this.getAllFieldsForSet(setBlockId)
      
    },
    copyBlock() {
      let block = JSON.parse(JSON.stringify(this.storeState.block))
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      block.uuid = blockId
      block.title = `${this.storeState.block.title}-copy`
      this.storeState.block = block
      this.storeState.blocks[this.storeState.block.uuid] = this.storeState.block
      store.updateBlock({gotBlock: this.storeState.gotBlock})
      this.$router.push({ name: 'Run', params: {id: block.uuid }}).catch(err => console.error(err))
    },
    shareBlock() {
      let url = `https://app.seekwell.io/run/${this.storeState.block.uuid}`
      this.$copyText(url)
      this.storeState.snackbar = true;
      this.storeState.message = 'Copied to clipboard';
    },
    openSheet() {
      let url = store.getSheetUrl()
      const win = window.open(url, '_blank')
    },
    runCode() {
      if (this.storeState.block.set && this.storeState.block.set.type === 'json') {
        let code = store.generateSetSql({test: true})
        store.runSet({code: code})
      } else if (this.storeState.block.code.length === 0) {
        this.storeState.snackbar = true;
        this.storeState.message = 'You need to write a query first';
        setTimeout(() => {
          if (this.$refs.cm) this.$refs.cm.codemirror.focus()
        }, 100);
      } else {
        store.runCode({})
      }
    },
    codeTimerFormat(jsTimeStamp) {
      var ms = (Date.now() - jsTimeStamp);
      var seconds = (ms / 1000);
      var interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return (seconds / 3600).toFixed(1) + " hours";
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return (seconds / 60).toFixed(1) + "m";
      }
      interval = Math.floor(seconds / 60);
      return (seconds).toFixed(1) + "s";
    },
    cancelRun() {
      clearInterval(this.storeState.codeTimerInterval)
      store.cancelRun({})
    },
    setSchedule() {
      this.showDestination = true;
    },
    updateDestination() {
      this.showDestination = true
    },
    favoriteBlock() {
      this.storeState.block.favorite = !this.storeState.block.favorite
      // this.$refs.title.focus()
      if (this.storeState.block.favorite) {
        setTimeout(() => {
          this.$refs.title.focus()
        }, 0);
      }
    },
    addSource() {
      console.log('adding source...')
      this.storeState.addingSource = true
    },
    editSources() {
      console.log('edit source...')
      this.$router.push({ name: 'Sources' }).catch(err => console.error(err))
    },
    sheetsAsSource() {
      console.log('adding source...')
      this.storeState.block.cellType = 'sheetsAsSql'
      // this.storeState.block.source = {
      //   name: 'Sheets',
      //   uuid: 'googlesheets',
      //   type: 'sheets',
      //   meta: false,
      //   spreadsheetId: false,
      //   sheets: [],
      // }
      // this.storeState.allSources.push(this.storeState.block.source)
    },
    saveBlock() {
      store.updateBlock({gotBlock: this.storeState.gotBlock})
      this.$router.push({ name: 'Blocks' }).catch(err => console.error(err))
    },
    validateSource() {
      //all
      if (!this.newSource.name) {
        this.$refs.newSourceName.focus()
        return false
      }
      if (!this.newSource.username) {
        this.$refs.newSourceUsername.focus()
        return false
      }
      //not snowflake
      if (this.newSource.db_type != 'snowflake' && !this.newSource.host) {
        this.$refs.newSourceHost.focus()
        return false
      }
      if (this.newSource.db_type != 'snowflake' && (this.newSource.host.startsWith('https:') || this.newSource.host.startsWith('http:'))) {
        this.$refs.newSourceHost.focus()
        this.connectError = 'Do not include HTTP / HTTPS in the host name'
        return false
      }
      //snowflake
      if (this.newSource.db_type === 'snowflake' && !this.newSource.accountName) {
        this.$refs.newSourceAccountName.focus()
        return false
      }
      return true
    },
    saveSource() {
      let valid = this.validateSource()
      if (!valid) return
      const path = store.getPath('/soup_save_source')
      const d = this.newSource
      d.sessionId = this.storeState.sessionId
      var self = this
      self.savingSource = true
      axios.post(path, d)
        .then((res) => {
          console.log('got soup_save_source: ', res.data)
          self.storeState.block.source.uuid = res.data.block_uuid
          self.testRunSource(self)
        })
        .catch((error) => {
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    timeoutTest(self) {
      if (self.savingSource) {
        self.whitelistError = true
        self.savingSource = false
        self.storeState.snackbar = true;
        self.storeState.message = 'Connection took longer than 15 seconds, check your connection properties and try again';
      }
    },
    testRunSource(self) {
      let block = store.cleanUpBlock(self.storeState.block);
      let data = {
        sessionId: self.storeState.sessionId,
        block: block,
        test: true
      }
      setTimeout(() => {
        self.timeoutTest(self)
      }, 15000);
      axios.post(store.getPathRunner('/run_one'), data)
        .then((res) => {
          if (res.data.ok) {
            console.log('testRunSource: ', res.data)
            self.storeState.addingSource = false
            self.savingSource = false
            self.storeState.snackbar = true;
            self.storeState.message = 'Source added!';
            self.$parent.getSoupSources()
          } else {
            console.error('testRunSource error: ', res.data)
            self.savingSource = false
            self.storeState.snackbar = true
            let err = res.data.error.replace('<', '')
            self.storeState.message = err
            self.connectError = err
          }
        })
        .catch((error) => {
          console.error('runCode error', error)
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    getExplore(self) {
      console.log('getExplore...')
      if (!self.storeState.block.source.uuid) return
      if (self.storeState.block.cellType === 'set') return
      let block = JSON.parse(JSON.stringify(self.storeState.block))
      let source = self.storeState.allSources.find(s => s.block_uuid === block.source.uuid)
      block.code = self.storeState.exploreSqlDict[source.db_type]
      block.destination = {}
      block.repeat = {}
      block.limit = 10000
      let data = {
        sessionId: self.storeState.sessionId,
        block: block,
      }
      axios.post(store.getPathRunner('/run_one'), data)
        .then((res) => {
          if (res.data.ok) {
            console.log('getExplore done: ', res.data)
            self.storeState.snackbar = true;
            self.storeState.message = 'Explore refreshed!';
            self.storeState.dbMeta = res.data
            let source = self.storeState.sources.find(s => s.block_uuid === self.storeState.block.source.uuid)
            if (source) {
              source.meta = self.storeState.dbMeta 
            }
            self.storeState.dbMeta.tables = []
            for (let i = 0; i < self.storeState.dbMeta.df.length; i++) {
              let meta = self.storeState.dbMeta.df[i];
              if (meta.table_schema) {
                var table = `${meta.table_schema}.${meta.table_name}`
              } else {
                var table = `${meta.table_name}`
              }
              if (!self.storeState.dbMeta.tables.includes(table) && meta.table_schema != 'information_schema') {
                self.storeState.dbMeta.tables.push(table)
              }
            }
            // self.$parent.getSoupSources()
          } else {
            console.error('getExplore error: ', res.data)
            self.savingSource = false
            self.storeState.snackbar = true;
            self.storeState.message = res.data.error;
            self.connectError = res.data.error
          }
        })
        .catch((error) => {
          console.error('getExplore error', error)
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    changeDestinationType(e, b) {
      console.log(e, b)
    },
    getParams(code) {
      var params = code.match(/{{([^{}]*)}}/g)
      if (!params) {
        return false
      }
      let params2 = []
      let uniqueNames = []
      for (let i = 0; i < params.length; i++) {
        let name = params[i].replace('{{', '').replace('}}', '')
        if (!uniqueNames.includes(name)) {
          let type = name.startsWith('$') ? 'sheets' : 'basic'
          let p = {name: name, value: '', type: type}
          params2.push(p)
          uniqueNames.push(name)
        }
      }
      if (params2.length > 0) {
        return params2
      }
      return false
    },
    getIndicesOf(searchStr, str, caseSensitive) {
      var searchStrLen = searchStr.length;
      if (searchStrLen == 0) {
          return [];
      }
      var startIndex = 0, index, indices = [];
      if (!caseSensitive) {
          str = str.toLowerCase();
          searchStr = searchStr.toLowerCase();
      }
      while ((index = str.indexOf(searchStr, startIndex)) > -1) {
          indices.push(index);
          startIndex = index + searchStrLen;
      }
      return indices;
    },
    getTableAliases(tabNames, code) {
      let aliases = {}
      for (let i = 0; i < tabNames.length; i++) {
          let indices = this.getIndicesOf(tabNames[i], code, false)
          if (indices.length > 0) {
              for (let i2 = 0; i2 < indices.length; i2++) {
                  let pos = window.editor.posFromIndex(indices[i2]);
                  var afterTable = window.editor.getRange(pos, {line: pos.line, ch: pos.ch + tabNames[i].length + 100}).split(' ')
                  var afterTableLower = afterTable.map(v => v.toLowerCase());
                  if (afterTable && afterTableLower.includes('as') && (afterTableLower.length > afterTableLower.indexOf('as')+1)) {
                      afterTable = afterTable[afterTableLower.indexOf('as')+1]
                  } else if (afterTable[1]) {
                      afterTable = afterTable[1]
                  }
                  if (afterTable) aliases[afterTable] = tabNames[i]
              }
          }
      }
      return aliases
    },
    getQuerySection(code, editor, cur) { //finds where you are in a query, e.g. SELECT, FROM, WHERE, etc.
      return 'select'
    },
    everyLetterMatch(searchTerm, searchIn) {
      searchTerm = searchTerm.toLowerCase()
      var include = true
      var searchTermLen = searchTerm.length
      var searchInLen = searchIn.length
      var matches = 0
      var startMatch = searchIn.startsWith(searchTerm)
      for (let i = 0; i < searchTerm.length; i++) {
          if (!searchIn.includes(searchTerm[i].toLowerCase())) {
            include = false
            break
          } else {
            matches++
            //this chops off where the last letter was found, this means search letters need to be 
            //the same order as the match, e.g. segev = segment.events, but segev != vesg
            searchIn = searchIn.slice(searchIn.indexOf(searchTerm[i].toLowerCase()))
          }
      }
      var ratio = (matches * (startMatch+1)) * 1.0 / searchInLen * 1.0
      return {include: include, matches: matches, ratio: ratio}
    },
    filterBlocks(opts) {
      var blockResults = []
      opts.searchTerm = opts.searchTerm.toLowerCase()
      for (const blockId in this.storeState.blocks) {
        let block = this.storeState.blocks[blockId]
        if (blockId === this.storeState.block.uuid) {
          //pass
        } else if (block.code.toLowerCase().includes(opts.searchTerm)) {
          blockResults.push(block)
        } else if (block.title.toLowerCase().includes(opts.searchTerm)) {
          blockResults.push(block)
        }
      }
      blockResults = blockResults.slice(0, opts.numPerCategory)
      return blockResults.sort((a, b) => { return b.viewedOn - a.viewedOn;})
    },
    checkJoinData(join) {
      if (!join.leftTable) return false
      if (!join.leftTable.real_name) return false
      if (!join.leftTable.parent) return false
      if (!join.rightTable) return false
      if (!join.rightTable.real_name) return false
      if (!join.rightTable.parent) return false
      return true
    },
    validateJson(code) {
      var j = {valid: false, j: false}
      try {
        j.j = JSON.parse(code)
        this.jsonParseError = ''
      } catch (error) {
        j.error = error
        this.jsonParseError = error.message
      }
      return j
    },
    onCmReady(cm) {
      console.log('cm ready...')
    },
    onCmChange(code) {
      if (!window.editor) return
      this.storeState.block.code = code
      let params = this.getParams(code)
      if (params) {
        this.hasParams = true
        for (let i = 0; i < params.length; i++) {
          let p = params[i];
          if (this.storeState.block.params.length > 0) {
            let ex = this.storeState.block.params.find(p2 => p2.name === p.name)
            if (ex) {
              params[i] = ex
            }
          } else {
            this.storeState.block.params = params
          }
        }
        this.storeState.block.params = params
      } else {
        this.storeState.block.params = []
      }
    },
    onCmFocus() {
      window.editor = this.$refs.cm.codemirror
      this.showDestination = false
      this.storeState.tableExpanded = false
      this.storeState.currentFocus = 'code'
    },
    onCmBlur() {
      this.showDestination = false
      this.storeState.currentFocus = 'main'
    },
    onSpreadSheetChange(newVal) {
      console.log('onSpreadSheetChange', newVal)
      this.storeState.destinations.sheets = []
      this.loadingSheets = true
      this.getSheets()
    },
    onSpreadSheetChangeSource(newVal) {
      console.log('onSpreadSheetChange', newVal)
      this.storeState.block.source.sheets = []
      this.getSheetsSource()
    },
    getSheetsSource() {
      const path = store.getPath('/soup_get_sheets')
      let d = {sessionId: this.storeState.sessionId, ss_id: this.storeState.block.source.spreadsheetId}
      var self = this
      axios.post(path, d)
        .then((res) => {
          console.log('got soup_get_sheets: ', res.data)
          if (!res.data.sheets) {
            this.storeState.snackbar = true;
            this.storeState.message = 'Error getting Sheets metadata';
            return
          }
          self.loadingSheets = false
          self.storeState.block.source.sheets = res.data.sheets.map(s => s.properties.title)
          self.$forceUpdate()
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getSheets() {
      const path = store.getPath('/soup_get_sheets')
      let d = {sessionId: this.storeState.sessionId, ss_id: this.storeState.block.destination.ss_id}
      var self = this
      axios.post(path, d)
        .then((res) => {
          console.log('got soup_get_sheets: ', res.data)
          if (!res.data.sheets) {
            this.storeState.snackbar = true;
            this.storeState.message = 'Error getting Sheets metadata';
            return
          }
          self.loadingSheets = false
          self.storeState.destinations.spreadSheetMetadata = res.data
          self.storeState.destinations.sheets = res.data.sheets.map(s => s.properties.title)
          self.$forceUpdate()
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    moment: function () {
      return moment();
    },
    getTags() {
      console.log('val term: ', this.newTag)
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
  },
  beforeCreate() {
    
  },
  created() {
    store.updateBlock = debounce(store.updateBlock, 150)
    this.getBlock(this.$route.params.id)
    window.bus.$on('focusRef',(details) => {
      console.log('focusRef.....', details)
      var ref = this.$refs[details.ref]
      if (ref) ref[0].focus()
    });
    // this.storeState.blockHistory.unshift(this.$route.params.id)
  },
};
</script>